import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/features/[slug]/page.tsx");
